import { cn } from '@tebuto/lib/utils'

export default function ExtraSmallText({
    children,
    className,
    ...rest
}: { children?: React.ReactNode } & React.HTMLAttributes<HTMLParagraphElement>) {
    return (
        <p {...rest} className={cn('xs:text-xxs text-[0.65rem] text-foreground-muted', className)}>
            {children}
        </p>
    )
}
